import { SoftphoneCall } from "@/lib/sip";
import { Button } from "react-bootstrap";

const LABELS: Record<SoftphoneCall['state'], string> = {
  ringing: "Appel entrant", dialing: "Appel en cours…", answering: "Connexion…",
  active: "En communication", holding: "Mise en attente…", held: "En attente",
  resuming: "Reprise…", paused: "Micro coupé — reprendre pour parler",
  uncertain: "Confirmation en attente — micro coupé", ending: "Fin de l’appel…",
};
interface Props {
  calls: SoftphoneCall[];
  hasActiveCall: boolean;
  busy: boolean;
  onAnswer(id: string): void;
  onResume(id: string): void;
  onHangup(id: string): void;
}
export default function WebphoneCallQueue({ calls, hasActiveCall, busy, onAnswer, onResume, onHangup }: Props) {
  if (!calls.length) return null;
  return (
    <section aria-label="File d’appels" className="webphone-call-queue border-top px-3 pt-2 pb-1">
      <ul className="list-unstyled mb-0">
        {calls.map((call) => {
          const number = call.fromNumber ?? "Numéro indisponible";
          const incoming = call.state === "ringing";
          const resumable = call.state === "held" || call.state === "paused";
          return (
            <li key={call.id} className="webphone-queued-call py-2">
              <div className="fw-semi-bold text-break">{number}</div>
              <p className="fs--1 text-body-secondary mb-2" aria-live="polite">{LABELS[call.state]}</p>
              <div className="d-flex flex-wrap gap-2">
                {incoming && (
                  <Button size="sm" variant="success" disabled={busy} onClick={() => onAnswer(call.id)}>
                    {hasActiveCall ? "Répondre en mettant l’appel en attente" : "Répondre"}
                  </Button>
                )}
                {resumable && (
                  <Button size="sm" variant="primary" disabled={busy} aria-label={`Reprendre l’appel de ${number}`} onClick={() => onResume(call.id)}>
                    Reprendre
                  </Button>
                )}
                <Button size="sm" variant="outline-danger" disabled={call.state === "ending"}
                  aria-label={`${incoming ? "Refuser" : "Raccrocher"} l’appel de ${number}`} onClick={() => onHangup(call.id)}>
                  {incoming ? "Refuser" : "Raccrocher"}
                </Button>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
